// Polyfills
import 'array-flat-polyfill';
import 'url-search-params-polyfill';

// Imports
import Vue from "vue";
import Vuelidate from 'vuelidate';
import router from "./router";
import store from "./store";
import Checkout from "./Checkout";
import PortalVue from 'portal-vue'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

// Bugsnag
let bugsnagApiKey = window.bugsnagApiKey || null;
if (bugsnagApiKey) {
    var bugsnagClient = bugsnag(window.bugsnagApiKey);
    bugsnagClient.use(bugsnagVue, Vue);
}


Vue.config.productionTip = false;

Vue.filter("nok", function (value) {
    return value.toLocaleString('no-nb') + ',-';
});

Vue.use(PortalVue);
Vue.use(Vuelidate);


new Vue({
    router,
    store,
    render: createElement => {
        // Pass data attributes as props to the root component
        return createElement(Checkout, {
            props: {...document.querySelector('#checkout').dataset},
        });
    }
}).$mount('#checkout');
